const SET_IN_CART_ITEMS = 'SET_IN_CART_ITEMS';
const SET_ADDED_ITEM = 'SET_ADDED_ITEM';

export default {
	namespaced: true,
	state: {
		inCartItems: null,
		addedItem: null
	},
	actions: {
		setInCartItems({commit}, webitems) {
			commit(SET_IN_CART_ITEMS, webitems);
		},

		setAddedItem({commit}, webitem) {
			commit(SET_ADDED_ITEM, webitem);
		}
	},
	mutations: {
		[SET_IN_CART_ITEMS](state, webitems) {
			state.inCartItems = webitems;
		},
		[SET_ADDED_ITEM](state, webitem) {
			state.addedItem = webitem;
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL07-warning/MDL07-warning-vuex.js